/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import styles from '../../styles';
import Header from './components/Header.js';
import Failed from './components/Failed.js';
import Success from './components/Success.js';
import Form from './components/Form.js';

const Wrapper = styled.div`
`;

const Pane = styled.div`
  height: 100%;
  background-color: white;
  margin-bottom: 1rem;
  ${styles.borders.card}
  padding: 0;

  backgorund-color: gray;

  margin: 0.75rem;
  @media (max-width: 767px) {
    margin: 0.75rem 0 0 0;
  }

  @media (max-width: 767px) {
    border-radius: 0;
  }
`;


export default class Login extends React.Component {
  componentWillUnmount() {
    this.props.requests.login.handleReset();
  }

  render() {
    const { login } = this.props.requests;

    return (
      <Wrapper>
        <Pane>
          <Header product='My Subscriptions' />
          <div className='slds-p-around--large'>
            {!login.isCompleted && <Form loginRequest={login} />}
            {!login.isCompleted && login.isErrored && <Failed />}
            {login.isCompleted && !login.isErrored && <Success />}
          </div>
        </Pane>
      </Wrapper>
    );
  }
}
